import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const { token, user } = useSelector((state) => state.auth);

  if (!token || !user?.isVerified) {
    // Sauvegarder l'URL actuelle pour y revenir après la connexion
    return <Navigate to="/connect" state={{ from: location }} replace />;
  }

  return children;
};

export default PrivateRoute;
